module.exports = __webpack_public_path__ + "static/media/gestoria_rojo.90c12e22.svg";